import { render, staticRenderFns } from "./compose.vue?vue&type=template&id=63de897e&"
import script from "./compose.vue?vue&type=script&lang=js&"
export * from "./compose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports